(() => {
  if (customElements.get('cb-size-guide')) return;
  const parse = value => {
    const match = String(value).trim().match(/^(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm$/i);
    if (!match) return null;
    const dimensions = match.slice(1).map(n => Number(n.replace(',', '.'))).sort((a, b) => a - b);
    if (dimensions.some(n => n <= 0 || n > 500)) return null;
    return { raw: value, w: dimensions[0], h: dimensions[1], label: dimensions.join(' × ') + ' cm' };
  };
  class SizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const options = JSON.parse(this.querySelector('[data-guide-options]').textContent);
      const option = options.find(o => o.values.length && o.values.every(v => parse(v)));
      if (!option) return;
      this.sizes = option.values.map(parse);
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.cb-size-guide-open');
      this.setKeyboardFocus = enabled => {
        this.trigger.dataset.keyboardFocus = String(enabled);
        this.dialog.dataset.keyboardFocus = String(enabled);
      };
      this.onPointerDown = () => this.setKeyboardFocus(false);
      this.onKeyDown = event => {
        if (event.key === 'Tab' || event.key.startsWith('Arrow')) this.setKeyboardFocus(true);
      };
      document.addEventListener('pointerdown', this.onPointerDown, true);
      document.addEventListener('keydown', this.onKeyDown, true);
      this.setKeyboardFocus(false);
      this.section = this.closest('.shopify-section') || document;
      this.current = parse(option.selected) || this.sizes[0];
      this.maxW = Math.max(...this.sizes.map(s => s.w));
      this.maxH = Math.max(175, ...this.sizes.map(s => s.h));
      this.sceneW = 145 + this.maxW;
      this.floor = this.maxH + 30;
      this.querySelector('[data-guide-scene]').setAttribute('viewBox', `0 0 ${this.sceneW} ${this.floor + 16}`);
      this.querySelector('[data-guide-floor]').setAttribute('d', `M12 ${this.floor}H${this.sceneW - 12}`);
      this.querySelector('[data-guide-person]').setAttribute('transform', `translate(53 ${this.floor - 175})`);
      this.querySelector('[data-guide-height] path').setAttribute('d', `M29 ${this.floor - 175}V${this.floor}M25 ${this.floor - 175}h8M25 ${this.floor}h8`);
      this.querySelector('[data-guide-person-label]').setAttribute('y', this.floor - 183);
      const choices = this.querySelector('.cb-size-guide-choices');
      this.sizes.forEach(size => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = size.label;
        button.addEventListener('click', () => this.showSize(size));
        choices.append(button);
      });
      this.trigger.addEventListener('click', e => {
        e.stopPropagation();
        const selected = this.field?.querySelector('input:checked')?.value;
        this.showSize(this.sizes.find(s => s.raw === selected) || this.current);
        this.dialog.showModal();
        this.dialog.querySelector('[data-guide-close]').focus();
      });
      this.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', e => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.trigger.focus());
      this.mount();
      this.observer = new MutationObserver(() => this.mount());
      this.observer.observe(this.section, {childList:true, subtree:true});
    }
    mount() {
      if (this.trigger.isConnected && !this.contains(this.trigger)) return;
      this.field = [...this.section.querySelectorAll('variant-radios fieldset')].find(f => [...f.querySelectorAll('input[type=radio]')].some(i => this.sizes.some(s => s.raw === i.value)));
      const groupName = this.field?.querySelector('.product-group-name');
      const legend = groupName && getComputedStyle(groupName).display !== 'none' ? groupName : this.field?.querySelector('legend');
      if (!legend) return;
      legend.classList.add('cb-size-guide-legend');
      legend.append(this.trigger);
      this.trigger.hidden = false;
    }
    showSize(size) {
      this.current = size;
      const x = 120 + (this.maxW - size.w) / 2;
      const y = this.floor - (this.maxH + size.h) / 2;
      for (const rect of this.querySelectorAll('[data-guide-art-rect],[data-guide-art-shadow]')) {
        for (const [name, value] of Object.entries({x,y,width:size.w,height:size.h})) rect.setAttribute(name,value);
      }
      const iconSize = Math.min(28, size.w * .45, size.h * .45);
      this.querySelector('[data-guide-art-icon]').setAttribute('transform', `translate(${x + (size.w - iconSize) / 2} ${y + (size.h - iconSize) / 2}) scale(${iconSize / 24})`);
      this.querySelector('[data-guide-current]').textContent = size.label;
      this.querySelectorAll('.cb-size-guide-choices button').forEach((b,i) => b.setAttribute('aria-pressed', String(this.sizes[i].raw === size.raw)));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('pointerdown', this.onPointerDown, true);
      document.removeEventListener('keydown', this.onKeyDown, true);
      this.trigger?.remove();
    }
  }
  customElements.define('cb-size-guide', SizeGuide);
})();
